export const TRANSFER = '/tag/transfer';
export const TRANSFER_TAG = suffix => `/tag/transfer/${suffix}`;
export const TRANSFER_TAG_SUMMARY = '/tag/transfer/summary';